export class RegistrationRateLimitedError extends Error {
  constructor() {
    super('There have been too many attempts to create an account. Please try again in a few minutes.')
    Object.setPrototypeOf(this, RegistrationRateLimitedError.prototype)
  }
}
